import '@mantine/core/styles.css';
import '@mantine/notifications/styles.css';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import Home from './components/pages/Home';
import NameGenerator from './components/pages/NameGenerator';
import Legal from './components/pages/Legal';

/**
 * Helper component that scrolls the window to the top whenever the route changes.
 */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

/**
 * Main application component that sets up routing and global scroll behavior.
 */
function App() {
  return (
    <Router>
        <ScrollToTop />
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/names" element={<NameGenerator />} />
            <Route path="/terms" element={<Legal sectionId="terms" />} />
            <Route path="/privacy" element={<Legal sectionId="privacy" />} />

            <Route path="*" element={<Home />} />
        </Routes>
    </Router>
  );
}

export default App;